import React from "react";
import {IconShare} from "@unibuddy/icons";
import {Button} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";

import {IntlNamespaces} from "../../../../translations/types";
import {INTL_COPIED_TO_CLIPBOARD} from "../../../../translations/mentorCard";
import {useCopyToClipboard} from "../../../../hooks/useCopyToClipBoard";

type BlogShareButtonProps = {
    shareUrl: string;
    onCopy?: () => void | Promise<void>;
};

// TODO: FIND DIFFERENT WAY, CURRENTLY VERY SIMILAR TO SHARE BUTTON in SHARED
export const BlogShareButton = ({shareUrl, onCopy}: BlogShareButtonProps) => {
    const {t} = useTranslation(IntlNamespaces.MENTOR_CARD);
    const {copyToClipboard} = useCopyToClipboard();

    /**
     * Copies the share URL to the clipboard where supported and shows an alert.
     *
     * The navigator.clipboard feature is available only in secure contexts
     * (HTTPS or localhost), in all major browsers.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/clipboard
     */
    const handleCopy = async () => {
        const copied = await copyToClipboard(shareUrl);
        if (!copied) return;

        onCopy?.();

        // eslint-disable-next-line no-alert
        alert(t(INTL_COPIED_TO_CLIPBOARD.key, INTL_COPIED_TO_CLIPBOARD.defaultValue));
    };

    return (
        <Button
            style={{padding: "0px"}}
            color="university"
            clear
            size="sm"
            onClick={() => {
                handleCopy();
            }}
        >
            <IconShare color={"grey150"} width={"20px"} height={"20px"} />
            {/** TODO: Need to add translation */}
            {t("blogs:share", "Share")}
        </Button>
    );
};
